export const order = 10;
export const routes = {
  path: "/sys",
  name: "SystemManagement",
  component: () => import("@/views/layout"),
  meta: {
    title: "系统管理",
    guard: {
      role: ["Admin"],
      permission: ["upms:sys"],
    },
  },
  children: [
    {
      path: "org",
      name: "OrgManagement",
      meta: {
        title: "组织",
        icon: "ri-organization-chart",
        guard: {
          role: ["Admin"],
          permission: ["upms:sys:org"],
        },
      },
      children: [
        {
          path: "campus",
          name: "OrgManagementCampus",
          component: () => import("@/views/sys/org/campus"),
          meta: {
            title: "校区维护",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:campus"],
            },
          },
        },
        {
          path: "frame",
          name: "OrgManagementFrame",
          component: () => import("@/views/sys/org/frame"),
          meta: {
            title: "组织架构",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:frame"],
            },
          },
        },
        {
          path: "dept",
          name: "OrgManagementDept",
          component: () => import("@/views/sys/org/dept"),
          meta: {
            title: "部门 / 单位",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:dept"],
            },
          },
        },
        {
          path: "college",
          name: "College",
          component: () => import("@/views/sys/org/college"),
          meta: {
            title: "学院",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:college"],
            },
          },
        },
        {
          path: "major",
          name: "OrgManagementMajor",
          component: () => import("@/views/sys/org/major"),
          meta: {
            title: "专业",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:major"],
            },
          },
        },
        {
          path: "class",
          name: "OrgManagementClass",
          component: () => import("@/views/sys/org/class"),
          meta: {
            title: "班级",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:class"],
            },
          },
        },
        {
          path: "organization",
          name: "Organization",
          component: () => import("@/views/sys/org/organization"),
          meta: {
            title: "机构管理",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:organization"],
            },
          },
        },
        {
          path: "thirdManage",
          name: "ThirdManage",
          component: () => import("@/views/sys/org/thirdManage"),
          meta: {
            title: "第三方管理",
            guard: {
              permission: ["upms:sys:org:thirdManage"],
            },
          },
        },
        {
          path: "visitorDept",
          name: "VisitorDept",
          component: () => import("@/views/sys/org/visitorDept"),
          meta: {
            title: "访客部门",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:visitorDept"],
            },
          },
        },
        {
          path: "alumniDept",
          name: "AlumniDept",
          component: () => import("@/views/sys/org/alumniDept"),
          meta: {
            title: "校友部门",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:org:alumniDept"],
            },
          },
        },
      ],
    },
    {
      path: "staff",
      name: "staffManagement",
      meta: {
        title: "人员",
        icon: "ri-account-circle-fill",
        guard: {
          role: ["Admin"],
          permission: ["upms:sys:staff"],
        },
      },
      children: [
        {
          path: "pupil",
          name: "pupil",
          component: () => import("@/views/sys/staff/pupil"),
          meta: {
            title: "学生账号",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:staff:pupil"],
            },
          },
        },
        {
          path: "faculty",
          name: "faculty",
          component: () => import("@/views/sys/staff/faculty"),
          meta: {
            title: "教工账号",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:staff:faculty"],
            },
          },
        },
        {
          path: "faculty/perm/:tchIds",
          name: "ConfigTchPerm",
          component: () => import("@/views/sys/staff/faculty/perm"),
          meta: {
            title: "设置权限",
            activeMenu: "/sys/staff/faculty",
            hidden: true,
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:staff:faculty:setPerm"],
            },
          },
        },
        {
          path: "third",
          name: "Third",
          component: () => import("@/views/sys/staff/third"),
          meta: {
            title: "第三方账号",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:staff:third"],
            },
          },
        },
        {
          path: "counselor",
          name: "Counselor",
          component: () => import("@/views/sys/staff/counselor"),
          meta: {
            title: "辅导员管理",
            breadcrumbHidden: true,
            guard: {
              permission: ["upms:sys:staff:counselor"],
            },
          },
        },
      ],
    },
    {
      path: "log",
      name: "LogManagement",
      meta: {
        title: "日志",
        icon: "ri-file-text-line",
        guard: {
          role: ["Admin"],
          permission: ["upms:sys:log"],
        },
      },
      children: [
        {
          path: "sign",
          name: "LogManagementSign",
          component: () => import("@/views/sys/log/sign"),
          meta: {
            title: "登录日志",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:log:sign"],
            },
          },
        },
        {
          path: "operate",
          name: "LogOperate",
          component: () => import("@/views/sys/log/operate"),
          meta: {
            title: "业务日志",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:log:operate"],
            },
          },
        },
        {
          path: "managementOperate",
          name: "LogManagementOperate",
          component: () => import("@/views/sys/log/management"),
          meta: {
            title: "系统日志",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:log:managementOperate"],
            },
          },
        },
      ],
    },
    {
      path: "config",
      name: "ConfigManagement",
      meta: {
        title: "配置",
        icon: "ri-settings-4-fill",
        guard: {
          role: ["Admin"],
          permission: ["upms:sys:config"],
        },
      },
      children: [
        {
          path: "term",
          name: "ConfigManagementTerm",
          component: () => import("@/views/sys/config/term"),
          meta: {
            title: "学期设置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:term"],
            },
          },
        },
        {
          path: "basics",
          name: "ConfigManagementBasics",
          component: () => import("@/views/sys/config/basics"),
          meta: {
            title: "基础设置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:basics"],
            },
          },
        },
        {
          path: "safe",
          name: "ConfigManagementSafe",
          component: () => import("@/views/sys/config/safe"),
          meta: {
            title: "安全设置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:safe"],
            },
          },
        },
        {
          path: "note",
          name: "ConfigManagementNote",
          component: () => import("@/views/sys/config/note"),
          meta: {
            title: "短信配置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:note"],
            },
          },
        },
        {
          path: "wechat",
          name: "ConfigManagementWechat",
          component: () => import("@/views/sys/config/wechat"),
          meta: {
            title: "微信配置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:wechat"],
            },
          },
        },
        {
          path: "save",
          name: "ConfigManagementSave",
          component: () => import("@/views/sys/config/save"),
          meta: {
            title: "存储配置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:save"],
            },
          },
        },
        {
          path: "post",
          name: "ConfigManagementPost",
          component: () => import("@/views/sys/config/post"),
          meta: {
            title: "岗位设置",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:post"],
            },
          },
        },
        {
          path: "post/perm/:id",
          name: "ConfigManagementPerm",
          component: () => import("@/views/sys/config/post/perm"),
          meta: {
            title: "分配权限",
            activeMenu: "/sys/config/post",
            hidden: true,
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:post:perm"],
            },
          },
        },
        {
          path: "terminal",
          name: "ConfigManagementTerminal",
          component: () => import("@/views/sys/config/terminal"),
          meta: {
            title: "终端管理",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:terminal"],
            },
          },
        },
        {
          path: "dict",
          name: "ConfigManagementDict",
          component: () => import("@/views/sys/config/dict"),
          meta: {
            title: "数据字典",
            guard: {
              role: ["Admin"],
              permission: ["upms:sys:config:dict"],
            },
          },
        },
      ],
    },
  ],
};
export const perms = {
  OrgManagementCampus: [
    {
      title: "新增校区",
      permission: "upms:sys:org:campus:add",
    },
    { title: "删除", permission: "upms:sys:org:campus:del" },
    { title: "修改", permission: "upms:sys:org:campus:edit" },
  ],
  OrgManagementFrame: [
    {
      title: "批量导入",
      permission: "upms:sys:org:frame:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:org:frame:export",
    },
    {
      title: "拉取数据",
      permission: "upms:sys:org:frame:pull",
    },
    {
      title: "拉取结果导出",
      permission: "upms:sys:org:frame:pullExport",
    },
  ],
  OrgManagementDept: [
    {
      title: "新增单位",
      permission: "upms:sys:org:dept:add",
    },
    { title: "删除", permission: "upms:sys:org:dept:del" },
    { title: "修改", permission: "upms:sys:org:dept:edit" },
    {
      title: "导入",
      alias: "导入(产教融合)",
      permission: "upms:sys:org:dept:import",
    },
    {
      title: "导出",
      alias: "导出(产教融合)",
      permission: "upms:sys:org:dept:export",
    },
  ],
  OrgManagementMajor: [
    {
      title: "新增专业",
      permission: "upms:sys:org:major:add",
    },
    { title: "删除", permission: "upms:sys:org:major:del" },
    { title: "修改", permission: "upms:sys:org:major:edit" },
    {
      title: "批量导入",
      permission: "upms:sys:org:major:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:org:major:export",
    },
    {
      title: "更新班级数量",
      permission: "upms:sys:org:major:refresh",
    },
    {
      title: "更新专业代码",
      permission: "upms:sys:org:major:refreshCode",
    },
  ],
  OrgManagementClass: [
    {
      title: "新增班级",
      permission: "upms:sys:org:class:add",
    },
    { title: "删除", permission: "upms:sys:org:class:del" },
    { title: "修改", permission: "upms:sys:org:class:edit" },
    {
      title: "批量导入",
      permission: "upms:sys:org:class:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:org:class:export",
    },
    {
      title: "更新班级人数",
      permission: "upms:sys:org:class:refresh",
    },
  ],
  staffManagementPupil: [
    {
      title: "新增学生",
      permission: "upms:sys:staff:pupil:add",
    },
    { title: "删除", permission: "upms:sys:staff:pupil:del" },
    { title: "修改", permission: "upms:sys:staff:pupil:edit" },
    {
      title: "批量导入",
      permission: "upms:sys:staff:pupil:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:staff:pupil:export",
    },
    {
      title: "重置密码",
      permission: "upms:sys:staff:pupil:pwd",
    },
    {
      title: "毕业生批量禁用",
      permission: "upms:sys:staff:pupil:disabled",
    },
    {
      title: "更新一卡通",
      permission: "upms:sys:staff:pupil:fresh",
    },
  ],
  staffManagementCase: [
    { title: "删除", permission: "upms:sys:staff:case:del" },
    { title: "底册导入", permission: "upms:sys:staff:case:import" },
    { title: "底册导出", permission: "upms:sys:staff:case:export" },
    { title: "修改在校状态", permission: "upms:sys:staff:case:zxStatus" },
    { title: "修改在津状态", permission: "upms:sys:staff:case:zjStatus" },
    { title: "毕业生归档", permission: "upms:sys:staff:case:file" },
  ],
  staffManagementFaculty: [
    {
      title: "新增教工",
      permission: "upms:sys:staff:faculty:add",
    },
    {
      title: "修改",
      permission: "upms:sys:staff:faculty:edit",
    },
    { title: "删除", permission: "upms:sys:staff:faculty:del" },
    { title: "批量导入", permission: "upms:sys:staff:faculty:import" },
    { title: "批量导出", permission: "upms:sys:staff:faculty:export" },
    { title: "重置密码", permission: "upms:sys:staff:faculty:pwd" },
    { title: "岗位清空", permission: "upms:sys:staff:faculty:clear" },
    { title: "企业微信绑定", permission: "upms:sys:staff:faculty:wechat" },
    { title: "更新一卡通", permission: "upms:sys:staff:faculty:fresh" },
    { title: "岗位调动", permission: "upms:sys:staff:faculty:post" },
    { title: "辅导员调班", permission: "upms:sys:staff:faculty:fdy" },
  ],
  staffManagementOthers: [
    {
      title: "新增人员",
      permission: "upms:sys:staff:others:add",
    },
    {
      title: "修改",
      permission: "upms:sys:staff:others:edit",
    },
    { title: "删除", permission: "upms:sys:staff:others:del" },
    { title: "初始化导入", permission: "upms:sys:staff:others:import" },
    { title: "初始化导出", permission: "upms:sys:staff:others:export" },
    { title: "重置密码", permission: "upms:sys:staff:others:pwd" },
    { title: "岗位清空", permission: "upms:sys:staff:others:clear" },
    { title: "岗位调动", permission: "upms:sys:staff:others:post" },
  ],
  ConfigManagementTerm: [
    {
      title: "新增学期",
      permission: "upms:sys:config:term:add",
    },
    { title: "删除", permission: "upms:sys:config:term:del" },
    { title: "修改", permission: "upms:sys:config:term:edit" },
  ],
  ConfigManagementSave: [
    {
      title: "新增存储",
      permission: "upms:sys:config:save:add",
    },
  ],
  ConfigManagementPost: [
    {
      title: "新增岗位",
      permission: "upms:sys:config:post:add",
    },
    { title: "删除", permission: "upms:sys:config:post:del" },
    { title: "修改", permission: "upms:sys:config:post:edit" },
    { title: "复制", permission: "upms:sys:config:post:copy" },
    { title: "分配权限", permission: "upms:sys:config:post:perm" },
    { title: "批量导入", permission: "upms:sys:config:post:import" },
    { title: "批量导出", permission: "upms:sys:config:post:export" },
  ],
  ConfigManagementNote: [
    { title: "编辑", permission: "upms:sys:config:note:edit" },
  ],
  ConfigManagementWechat: [
    { title: "编辑", permission: "upms:sys:config:wechat:edit" },
  ],
  ConfigManagementTerminal: [
    { title: "编辑", permission: "upms:sys:config:terminal:edit" },
    { title: "详情", permission: "upms:sys:config:terminal:detail" },
    { title: "删除", permission: "upms:sys:config:terminal:del" },
    { title: "新增", permission: "upms:sys:config:terminal:add" },
  ],
  ConfigManagementDict: [
    { title: "新增", permission: "upms:sys:config:dict:add" },
    { title: "删除", permission: "upms:sys:config:dict:del" },
    { title: "编辑", permission: "upms:sys:config:dict:edit" },
    { title: "添加子类", permission: "upms:sys:config:dict:addChild" },
  ],
  // 产教
  pupil: [
    {
      title: "新增学生",
      permission: "upms:sys:staff:pupil:add",
    },
    {
      title: "批量导入",
      permission: "upms:sys:staff:pupil:import",
    },
    {
      title: "批量导入学号异动",
      permission: "upms:sys:staff:pupil:importXh",
    },
    {
      title: "批量导出",
      permission: "upms:sys:staff:pupil:export",
    },
    { title: "删除", permission: "upms:sys:staff:pupil:del" },
    { title: "编辑", permission: "upms:sys:staff:pupil:edit" },
    {
      title: "重置密码",
      permission: "upms:sys:staff:pupil:pwd",
    },
  ],
  faculty: [
    {
      title: "新增教工",
      permission: "upms:sys:staff:faculty:add",
    },
    {
      title: "批量导入",
      permission: "upms:sys:staff:faculty:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:staff:faculty:export",
    },
    { title: "删除", permission: "upms:sys:staff:faculty:del" },
    { title: "编辑", permission: "upms:sys:staff:faculty:edit" },
    {
      title: "重置密码",
      permission: "upms:sys:staff:faculty:pwd",
    },
    {
      title: "分配岗位",
      permission: "upms:sys:staff:faculty:post",
    },
    {
      title: "企业微信绑定",
      permission: "upms:sys:staff:faculty:wechat",
    },
    {
      title: "设置权限",
      permission: "upms:sys:staff:faculty:setPerm",
    },
  ],
  Third: [
    { title: "新增第三方", permission: "upms:sys:staff:third:add" },
    { title: "修改", permission: "upms:sys:staff:third:edit" },
    { title: "删除", permission: "upms:sys:staff:third:del" },
    { title: "重置密码", permission: "upms:sys:staff:third:reset" },
    { title: "岗位调动", permission: "upms:sys:staff:third:move" },
    { title: "批量导出", permission: "upms:sys:staff:third:initExport" },
    { title: "批量导入", permission: "upms:sys:staff:third:initImport" },
  ],
  Counselor: [
    { title: "删除", permission: "upms:sys:staff:counselor:del" },
    { title: "批量导入", permission: "upms:sys:staff:counselor:import" },
    { title: "批量导出", permission: "upms:sys:staff:counselor:export" },
  ],
  College: [
    {
      title: "新增学院",
      permission: "upms:sys:org:college:add",
    },
    { title: "删除", permission: "upms:sys:org:college:del" },
    { title: "修改", permission: "upms:sys:org:college:edit" },
    {
      title: "批量导入",
      permission: "upms:sys:org:college:import",
    },
    {
      title: "批量导出",
      permission: "upms:sys:org:college:export",
    },
  ],
  Organization: [
    {
      title: "新增单位",
      permission: "upms:sys:org:organization:add",
    },
    { title: "删除", permission: "upms:sys:org:organization:del" },
    { title: "编辑", permission: "upms:sys:org:organization:edit" },
  ],
  ThirdManage: [
    {
      title: "新增科室",
      permission: "upms:sys:org:thirdManage:addOffice",
    },
    {
      title: "导入科室",
      permission: "upms:sys:org:thirdManage:importOffice",
    },
    {
      title: "编辑科室",
      permission: "upms:sys:org:thirdManage:editOffice",
    },
    { title: "删除科室", permission: "upms:sys:org:thirdManage:delOffice" },
    {
      title: "新增负责人",
      permission: "upms:sys:org:thirdManage:addHead",
    },
    {
      title: "导入负责人",
      permission: "upms:sys:org:thirdManage:importHead",
    },
    { title: "删除负责人", permission: "upms:sys:org:thirdManage:delHead" },
    {
      title: "编辑负责人",
      permission: "upms:sys:org:thirdManage:editHead",
    },
    {
      title: "新增第三方部门",
      permission: "upms:sys:org:thirdManage:add",
    },
    {
      title: "导入第三方部门",
      permission: "upms:sys:org:thirdManage:import",
    },
    {
      title: "编辑第三方部门",
      permission: "upms:sys:org:thirdManage:edit",
    },
    { title: "删除第三方部门", permission: "upms:sys:org:thirdManage:del" },
  ],
  VisitorDept: [
    {
      title: "新建部门",
      permission: "upms:sys:org:visitorDept:addDept",
    },
    {
      title: "新建审批人",
      permission: "upms:sys:org:visitorDept:addCheck",
    },
    {
      title: "导入部门",
      permission: "upms:sys:org:visitorDept:importDept",
    },
    {
      title: "导入审批人",
      permission: "upms:sys:org:visitorDept:importCheck",
    },
    {
      title: "删除部门",
      permission: "upms:sys:org:visitorDept:delDept",
    },
    {
      title: "删除审批人",
      permission: "upms:sys:org:visitorDept:delCheck",
    },
    {
      title: "编辑部门",
      permission: "upms:sys:org:visitorDept:editDept",
    },
    {
      title: "编辑审批人",
      permission: "upms:sys:org:visitorDept:editCheck",
    },
  ],
  AlumniDept: [
    {
      title: "新建部门",
      permission: "upms:sys:org:alumniDept:addDept",
    },
    {
      title: "新建审批人",
      permission: "upms:sys:org:alumniDept:addCheck",
    },
    {
      title: "导入部门",
      permission: "upms:sys:org:alumniDept:importDept",
    },
    {
      title: "导入审批人",
      permission: "upms:sys:org:alumniDept:importCheck",
    },
    {
      title: "删除部门",
      permission: "upms:sys:org:alumniDept:delDept",
    },
    {
      title: "删除审批人",
      permission: "upms:sys:org:alumniDept:delCheck",
    },
    {
      title: "编辑部门",
      permission: "upms:sys:org:alumniDept:editDept",
    },
    {
      title: "编辑审批人",
      permission: "upms:sys:org:alumniDept:editCheck",
    },
  ],
};
